import React from "react";
import { useLang } from "../../contexts/LanguageContext";

export default function Marquee() {
  const { t } = useLang();
  const text = t.marquee;
  const repeated = Array(6).fill(text).join("");

  return (
    <section
      data-testid="marquee-section"
      aria-hidden="true"
      className="border-y border-slate-200 bg-slate-50/60 py-5 overflow-hidden"
    >
      <div className="marquee-mask">
        <div className="flex w-max animate-marquee whitespace-nowrap">
          <span className="font-heading font-semibold tracking-[0.18em] uppercase text-xs text-slate-500">
            {repeated}
          </span>
          <span className="font-heading font-semibold tracking-[0.18em] uppercase text-xs text-slate-500">
            {repeated}
          </span>
        </div>
      </div>
    </section>
  );
}
